












import {Component, Prop, Watch} from "vue-property-decorator";
import {InputType} from "@/enums/InputType";
import months from "@/data/months";
import {Option} from "@/util/Option";
import {extend} from 'vee-validate';
import {integer} from 'vee-validate/dist/rules';
import FormGroup from "@/components/Form/InputComponents/FormGroup.vue";
import FormInput from "@/components/Form/InputComponents/FormInput.vue";
import Validatable from "@/components/Validatable.vue";
import FormSelect from "@/components/Form/InputComponents/FormSelect.vue";
import {User} from "@/util/User";
import {namespace} from "vuex-class";
import {Store} from "@/enums/Store";
import {Currency} from "@/enums/Currency";

const APP = namespace(Store.APP);

@Component({
  components: {FormSelect, FormInput, FormGroup}
})
export default class BirthdayForm extends Validatable {
  @Prop({required: true}) member!: User;
  @APP.State('storeId') storeId!: number;
  @APP.State('currency') currency!: Currency;
  @Watch('member', {deep: true})
  updateMember() {
    this.$emit('update:member', this.member)
  }

  TEXT = InputType.TEXT;
  NUMBER = InputType.NUMBER;

  days: Option[] = [];
  months: Option[] = [];
  years: Option[] = [];
  isGermany = false

  created(): void {
    if (this.storeId == 1){
      this.isGermany = true
    }

    extend('integer', {
      ...integer,
      message: this.$t('integer-invalid').toString()
    });

    for (let i = 1; i <= 31; i++) {
      const option = new Option(i.toString(), i);
      this.days.push(option)
    }

    for (let i = 0; i < 12; i++) {
      const option = new Option(this.$t(months[i]).toString(), i);
      this.months.push(option)
    }

    const currentYear = (new Date()).getFullYear();
    for (let i = currentYear; i >= currentYear - 100; i--) {
      const option = new Option(i.toString(), i);
      this.years.push(option)
    }

  }

  get date() {
    if (typeof this.member.dob == "string") {
      return new Date(this.member.dob);
    }

    if (this.member.dob) {
      return new Date(this.member.dob.getTime());
    }

    return new Date();
  }

  set day(days: number) {
    const date = this.date;
    date.setDate(days);
    this.$set(this.member, 'dob', date);
  }

  get day() {
    return this.date.getDate();
  }

  set month(month: number) {
    const date = this.date;
    date.setMonth(month);
    this.$set(this.member, 'dob', date);
  }

  get month() {
    return this.date.getMonth();
  }

  set year(year: number) {
    const date = this.date;
    date.setFullYear(year);
    this.$set(this.member, 'dob', date);
  }

  get year() {
    return this.date.getFullYear();
  }
}
